var chunkMapping = {
	"src_bootstrap_tsx": [
		"webpack/container/remote/notification/NotificationApp"
	],
	"webpack_container_remote_RemotePrescriptionManagement_PrescriptionSummaryApp": [
		"webpack/container/remote/RemotePrescriptionManagement/PrescriptionSummaryApp"
	],
	"webpack_container_remote_RemoteMembraneFunctionAndAdequacyCalculator_App": [
		"webpack/container/remote/RemoteMembraneFunctionAndAdequacyCalculator/App"
	],
	"webpack_container_remote_RemoteLabDataAdministration_App": [
		"webpack/container/remote/RemoteLabDataAdministration/App"
	],
	"webpack_container_remote_PatientEnrollment_PatientEnrollmentApp": [
		"webpack/container/remote/PatientEnrollment/PatientEnrollmentApp"
	],
	"webpack_container_remote_RemotePrescriptionManagement_App": [
		"webpack/container/remote/RemotePrescriptionManagement/App"
	],
	"webpack_container_remote_PatientEnrollment_GatewayOrderStandalone": [
		"webpack/container/remote/PatientEnrollment/GatewayOrderStandalone"
	],
	"webpack_container_remote_AdminUI_App": [
		"webpack/container/remote/AdminUI/App"
	],
	"webpack_container_remote_TreatmentsUI_App": [
		"webpack/container/remote/TreatmentsUI/App"
	]
};
var idToExternalAndNameMapping = {
	"webpack/container/remote/notification/NotificationApp": [
		"default",
		"./NotificationApp",
		"webpack/container/reference/notification"
	],
	"webpack/container/remote/RemotePrescriptionManagement/PrescriptionSummaryApp": [
		"default",
		"./PrescriptionSummaryApp",
		"webpack/container/reference/RemotePrescriptionManagement"
	],
	"webpack/container/remote/RemoteMembraneFunctionAndAdequacyCalculator/App": [
		"default",
		"./App",
		"webpack/container/reference/RemoteMembraneFunctionAndAdequacyCalculator"
	],
	"webpack/container/remote/RemoteLabDataAdministration/App": [
		"default",
		"./App",
		"webpack/container/reference/RemoteLabDataAdministration"
	],
	"webpack/container/remote/PatientEnrollment/PatientEnrollmentApp": [
		"default",
		"./PatientEnrollmentApp",
		"webpack/container/reference/PatientEnrollment"
	],
	"webpack/container/remote/RemotePrescriptionManagement/App": [
		"default",
		"./App",
		"webpack/container/reference/RemotePrescriptionManagement"
	],
	"webpack/container/remote/PatientEnrollment/GatewayOrderStandalone": [
		"default",
		"./GatewayOrderStandalone",
		"webpack/container/reference/PatientEnrollment"
	],
	"webpack/container/remote/AdminUI/App": [
		"default",
		"./App",
		"webpack/container/reference/AdminUI"
	],
	"webpack/container/remote/TreatmentsUI/App": [
		"default",
		"./App",
		"webpack/container/reference/TreatmentsUI"
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}